import { render, staticRenderFns } from "./AdminBasicConfig.vue?vue&type=template&id=52274b62&"
import script from "./AdminBasicConfig.vue?vue&type=script&lang=js&"
export * from "./AdminBasicConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports